import store from '@/store/root.store'
import {
    authenticationStore,
    ApplicantService,
    UserService,
    ClassifiersService
} from '@/store'
import { UserCredentials } from '@/store/entities'
import { ENVIRONMENT } from '@/commons/configuration'
import unAuthenticatedAxios from '@/commons/configuration/un.authenticated.axios'
import authenticatedAxios from '@/commons/configuration/authenticated.axios'
import { AuthenticationUtils } from '@/commons/utils/authentication'

export class AuthenticationService {
    static async login (authenticationToken: string): Promise<void> {
        const response = await unAuthenticatedAxios.get(ENVIRONMENT.userDataUrl, {
            headers: {
                'X-Auth-Token': authenticationToken
            }
        })
        const userCredentials = response.data as UserCredentials
        userCredentials.token = authenticationToken
        authenticationStore.saveUserCredentials(userCredentials)
    }

    static async refreshSession (): Promise<void> {
        try {
            // Outer catch is needed for resolveAuthorizationToken as it throws error
            authenticatedAxios.get(ENVIRONMENT.refreshSessionUrl, {
                headers: {
                    'X-Auth-Token': authenticationStore.resolveAuthorizationToken()
                }
            }).catch(() => undefined) // catch is needed as request is not awaited thus running in its own promise context
        } catch {
            // do nothing
        }
    }

    static async logout (): Promise<void> {
        AuthenticationUtils.clearSessionModalsAndTimeouts()
        try {
            // Outer catch is needed for resolveAuthorizationToken as it throws error
            // unAuthenticatedAxios is used as clearAll wipes authenticated axios token thus throwing error
            // and request is not made at all
            unAuthenticatedAxios.get(ENVIRONMENT.logoutUrl, {
                headers: {
                    'X-Auth-Token': authenticationStore.resolveAuthorizationToken()
                }
            }).catch(() => undefined) // catch is needed as request is not awaited thus running in it's own promise context
        } catch {
            // do nothing
        }
        ApplicantService.cancelRequests()
        UserService.cancelUserRrRequest()
        ClassifiersService.cancelRequests()
        await store.dispatch('clearAll')
    }
}
